import { WIDTH_PDF_PORTRAIT_WITHOUT_PADDING } from './constant'

export const getPdfHeightImage = (width = 0, height = 0) => {
  return height * (WIDTH_PDF_PORTRAIT_WITHOUT_PADDING / width)
}

export const cloneNodeIncludeContent = (el) => {
  const newEl = el.cloneNode()
  newEl.innerHTML = el.innerHTML
  delete newEl.id
  return newEl
}
